import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../environments/environment';
import {HeaderService} from './header.service';

@Injectable()
export class StaffService extends HeaderService {

    getStaffByFirm(id): Observable<any> {
        return this.http.get(environment.apiBaseUrl + 'get-staffs-by-firm/' + id, this.httpBearerOptions)
            .map((response: Response) => {
                return response;
            })
            // ...errors if any
            .catch((error: any) => Observable.throw(error.error || 'Server error'));
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/services/staff.service.ts